import { Injectable } from "@angular/core";


@Injectable()
export class User {
  name: string;
  username: string;
  email: string;
  password: string;
  isUserVerified: string;
  emailsignin: string;
  passwordsignin: string;
  repassword: string;
  flagcreateac: string;
  custid: any;
  created_date: string;
  address:string;
  city:string;
  zip:number;
  state:string;
}

export class GuestUser {
  username: string;
  email: string;
  emailg: string;
  mobilenumber: string;
  address: string;
  isGuest: boolean;
  city:string;
  zip:number;
  state:string;
}

export class NewPassword {
  enterNewPassword: string;
  confirmPassword: string;
}


